import { cn } from "@/lib/utils";

export function LiveBadge({ className, label = "LIVE" }: { className?: string; label?: string }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 rounded-sm bg-live px-2.5 py-1 text-[11px] font-bold uppercase tracking-[0.18em] text-white",
        className,
      )}
    >
      <span aria-hidden className="live-dot inline-block size-1.5 rounded-full bg-white" />
      {label}
    </span>
  );
}
